import { render } from "./decompose.vue?vue&type=template&id=20c7e7ae&scoped=true"
import script from "./decompose.vue?vue&type=script&lang=js"
export * from "./decompose.vue?vue&type=script&lang=js"

import "./decompose.vue?vue&type=style&index=0&id=20c7e7ae&lang=scss&scoped=true"

import exportComponent from "E:\\4-6 项目\\蚂蚁电能交易分析\\energy\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c7e7ae"]])

export default __exports__